import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';
import {
  DailyShareNOK,
  WeeklyShareNOK,
  MonthlyShareNOK,
  YearlyShareNOK,
} from '../typings/Analytics';

const analyticsUrl = '/carehome/acp-analytics';

const dailyShareNOK = async (
  parnerCarhomeId: string
): Promise<ApiResponse<DailyShareNOK[]>> => {
  const response = await axiosIns.get(
    `${analyticsUrl}/last-7-days/${parnerCarhomeId}`
  );
  return response.data;
};

const weeklyShareNOK = async (
  parnerCarhomeId: string
): Promise<ApiResponse<WeeklyShareNOK[]>> => {
  const response = await axiosIns.get(
    `${analyticsUrl}/last-7-weeks/${parnerCarhomeId}`
  );
  return response.data;
};
const monthlyShareNOK = async (
  parnerCarhomeId: string
): Promise<ApiResponse<MonthlyShareNOK[]>> => {
  const response = await axiosIns.get(
    `${analyticsUrl}/last-12-months/${parnerCarhomeId}`
  );
  return response.data;
};

const yearlyShareNOK = async (
  parnerCarhomeId: string
): Promise<ApiResponse<YearlyShareNOK[]>> => {
  const response = await axiosIns.get(
    `${analyticsUrl}/yearly/${parnerCarhomeId}`
  );
  return response.data;
};

export { dailyShareNOK, weeklyShareNOK, monthlyShareNOK, yearlyShareNOK };
